import { useMutation, type UseMutationResult } from '@tanstack/react-query'

import {
  type ViewServiceGetComboBoxSelectorElementsRequest,
  type V1GetComboBoxSelectorElementsResponse,
  type FetchError
} from 'mnvm-mypage-app-ts-if'
import { viewServiceApi } from '@/api/view-service-api'
import { type MutationConfig } from '@/lib/react-query'

export const getComboBoxSelectorElements = async (
  requestParameters: ViewServiceGetComboBoxSelectorElementsRequest
): Promise<V1GetComboBoxSelectorElementsResponse> => {
  return await viewServiceApi.viewServiceGetComboBoxSelectorElements(
    requestParameters
  )
}

interface UseComboBoxSelectorElementsOptions {
  config?: MutationConfig<typeof getComboBoxSelectorElements>
}

export const useComboBoxSelectorElements = ({
  config
}: UseComboBoxSelectorElementsOptions = {}): UseMutationResult<
  V1GetComboBoxSelectorElementsResponse,
  FetchError,
  ViewServiceGetComboBoxSelectorElementsRequest,
  unknown
> => {
  return useMutation({
    ...config,
    mutationFn: getComboBoxSelectorElements
  })
}
